import React, { useState } from 'react';
import { BarChart3, Settings, Users } from '../../icons';
import { useAppSettings } from '../../hooks/useAppSettings';
import { useUsers } from '../../hooks/useUsers';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useCacheConfig } from '../../hooks/useCacheConfig';
import InfoBannerSettings from './InfoBannerSettings';
import CacheSettings from './CacheSettings';
import UserManagement from './UserManagement';
import AnalyticsDashboard from './AnalyticsDashboard';
import AIPolicySettings from './AIPolicySettings';
import Chip, { ChipRow } from '../ui/Chip';

const AdminPanel = ({ userId, isAdmin, onImpersonate }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const { infoBanner, isLoading: settingsLoading, updateInfoBanner } = useAppSettings();
  const { users, isLoading: usersLoading, error: usersError, toggleAdmin, updateUserAI, refreshUsers } = useUsers(isAdmin);
  const { cacheConfig, isLoading: cacheConfigLoading, updateCacheConfig } = useCacheConfig();
  const {
    globalStats,
    cacheMetrics,
    isLoading: analyticsLoading,
    isRecalculating,
    error: analyticsError,
    recalculateStats
  } = useAnalytics(isAdmin);

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { id: 'settings', label: 'Settings', icon: Settings },
    { id: 'users', label: 'Users', icon: Users },
  ];

  return (
    <div className="space-y-4">
      {/* Tab Navigation */}
      <ChipRow>
        {tabs.map((tab) => (
          <Chip key={tab.id} icon={tab.icon} active={activeTab === tab.id} onClick={() => setActiveTab(tab.id)}>
            {tab.label}
          </Chip>
        ))}
      </ChipRow>

      {/* Tab Content */}
      <div>
        {activeTab === 'dashboard' && (
          <AnalyticsDashboard
            globalStats={globalStats}
            cacheMetrics={cacheMetrics}
            isLoading={analyticsLoading}
            isRecalculating={isRecalculating}
            error={analyticsError}
            onRecalculate={recalculateStats}
          />
        )}
        {activeTab === 'settings' && (
          <div className="space-y-4">
            <InfoBannerSettings
              settings={infoBanner}
              onSave={updateInfoBanner}
              userId={userId}
              isLoading={settingsLoading}
            />
            <CacheSettings
              cacheConfig={cacheConfig}
              isLoading={cacheConfigLoading}
              onSave={updateCacheConfig}
              userId={userId}
            />
            <AIPolicySettings userId={userId} />
          </div>
        )}
        {activeTab === 'users' && (
          <UserManagement
            users={users}
            isLoading={usersLoading}
            error={usersError}
            onToggleAdmin={toggleAdmin}
            onUpdateUserAI={updateUserAI}
            onImpersonate={onImpersonate}
            onRefresh={refreshUsers}
            currentUserId={userId}
          />
        )}
      </div>
    </div>
  );
};

export default AdminPanel;
